"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPhoneOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M15.678 13.368c.635-.29 1.264-.185 1.264-.185 1.586.301 2.74.523 3.463.666 0 0 .727.096 1.199.737.471.64.411 1.225.411 1.225V20c0 1.336-.645 2.002-1.936 1.999-.158.02-.317.034-.477.039-5.205 0-9.369-1.528-12.394-4.553-3.723-3.723-5.45-8.236-5.18-13.538C2.018 2.649 2.684 2 4.025 2c1.037 0 2.445 0 4.223.002 0 0 .714-.044 1.299.476s.664 1.154.664 1.154c.137.723.343 1.885.62 3.485 0 0 .134.655-.19 1.241-.214.369-.52.675-.889.89l-.574.289c.421 1.386 1.73 4.401 5.291 5.326l.317-.623s.256-.581.89-.872h.002zm4.348 6.666v-4.215l-3.45-.689-.367.727c-.1.198-.213.521-.749.781-.535.26-1.225.178-1.225.178a4.999 4.999 0 01-1.01-.246c-3.713-1.307-5.484-4.595-6.05-6.744a1.649 1.649 0 01.089-1.173c.24-.509.667-.728.847-.819l.777-.388L8.205 4H4.028c.073 2.276.662 8.147 4.603 12.08 2.713 2.708 6.54 4.053 11.395 3.954z' }))); };
exports.default = SvgPhoneOutline;
//# sourceMappingURL=PhoneOutline.js.map